import React from 'react';
import CardBody from './CardBody';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
const HomeBody = () => {
  const navigate = useNavigate();
  return (
    <div className={'container'}>
      <h1
        style={{
          fontWeight: 600,
          fontSize: 20,
          marginBottom: 30,
          color: '#000000',
        }}
      >
        About me
      </h1>
      <div
        style={{
          width: '100%',
          display: 'flex',
          boxShadow: '0px 2px 10px rgba(14, 48, 99, 0.25)',
          borderRadius: '10px',
        }}
      >
        <CardBody
          title={'My Absence'}
          subtitle={'Number of day off'}
          icon={'/assets/relaxation.svg'}
          data={''}
          btnTitle={'Create a request'}
          onButton={() => navigate('/leave_request')}
          isShowBtn={true}
          check={1}
        />{' '}
        <CardBody
          title={'My time & activities'}
          subtitle={`Date: ${dayjs().format('DD/MM/YYYY')} `}
          icon={'/assets/save_time.svg'}
          data={''}
          btnTitle={'Create a request'}
          isShowBtn={false}
        />
        <CardBody
          title={'My expense reports'}
          subtitle={'No expense report'}
          icon={'/assets/report.svg'}
          data={''}
        // btnTitle={'Reports'}
        // isShowBtn={true}
        />{' '}
        <CardBody
          // style={{ border: 'none' }}
          title={'My preference'}
          subtitle={'Interface change'}
          icon={'/assets/new_search.svg'}
          data={''}
          onButton={() => navigate('/my_preference')}
          btnTitle={'View'}
          isShowBtn={true}
          check={2}
        />
      </div>
    </div>
  );
};

export default HomeBody;
